import { TransfersTable } from '../../../components/tables/transfersTable/transfersTable';
import { ClientGroup } from '../../../interfaces';

export const HouseholdTransfers = ({ clientGroup }: { clientGroup: ClientGroup }) => (
  <TransfersTable level='CLIENT_GROUP' showClient filter={{ clientGroupId: clientGroup.id }}/>
);
